import type { Optional } from '@festina-life/core'

import { isComparisonUnchanged } from '../fplusDiff/diffModel'
import { TemplateParentLink } from '../templateParentLink/TemplateParentLink'
import { DiffEntry } from './DiffEntry'

type Props = {
  current: Optional<string>
  compare: Optional<string>
  title: string
}

/**
 * A template reference is a single identifier, where a diff would add noise
 * rather than information, so it keeps the before-beside-after presentation.
 */
export const ComparableTemplateDiff = ({ current, compare, title }: Props) => {
  if (isComparisonUnchanged(compare, current)) {
    return null
  }

  return (
    <DiffEntry
      title={title}
      compare={compare ? <TemplateParentLink templateId={compare} /> : '-'}
      current={current ? <TemplateParentLink templateId={current} /> : '-'}
    />
  )
}
